module.exports = __webpack_public_path__ + "img/bin.dfb24752.svg";